var render = function (_h,_vm) {var _c=_vm._c;return _c('li',[(!_vm.props.outside)?_c('router-link',{staticClass:"nav-item",attrs:{"to":_vm.props.link}},[_vm._v(" "+_vm._s(_vm.props.label)+" ")]):_c('a',{staticClass:"nav-item",attrs:{"href":_vm.props.link,"target":_vm.props.target}},[_vm._v(" "+_vm._s(_vm.props.label)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }